import { Link } from "react-router-dom";

export function BrandMark({ compact = false, to = "/" }: { compact?: boolean; to?: string }) {
  return <Link className="brand-mark" to={to} aria-label="LUNAVOA home"><span className="brand-symbol" aria-hidden="true"><i /><i /><i /></span><span><strong>LUNAVOA</strong>{!compact && <small>A world that grows with you.</small>}</span></Link>;
}
